<template>
  <v-container fluid>
  <v-layout>
    <v-flex xs12>
     <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="6000"
        absolute
        >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-layout row pb-1 mb-1>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-btn rounded small color="secondary"
                class="accent--text logoutbtn" @click="generateInvoice" :disabled="canGenerateInvoice || processingRequest"> Generate DDS </v-btn>
<!--                class="accent&#45;&#45;text logoutbtn" @click="generateInvoice" :disabled="canGenerateInvoice || processingRequest"> Generate Invoice </v-btn>-->
            <v-progress-linear v-if="showProgressBar" indeterminate></v-progress-linear>
          </v-flex>
      </v-layout>

     <!-- <v-data-table
        v-model="selected"
        :headers="headers"
        :items="invoices"
        show-select
        class="elevation-1"
      > -->
      <v-data-table
       v-model="selected"
        :headers="headers"
        :items="data"
        :loading="loadingPage"
        :server-items-length="totalData"
        :options.sync="pagination"
  show-select
  class="elevation-1"
>


      <template v-slot:item.dateBought="{ item }">
         {{item.dateBought | prettyDate }}
      </template>
      </v-data-table>
     <!-- Loading Overlay -->
     <v-overlay :value="loadingPage">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
    </v-flex>

    <v-dialog v-model="ddsDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text">
          Generate DDS
        </v-card-title>

        <v-card-text>
          <v-form
            ref="ddsForm"
            v-model="ddsFormValid"
            lazy-validation
          >

            <!-- Buyer -->
            <v-text-field
              v-model="ddsForm.buyerName"
              label="Buyer Name"
              placeholder="Enter buyer name"
              :rules="buyerNameRules"
              required
              outlined
            ></v-text-field>

            <!-- Country -->
            <v-select
              v-model="ddsForm.destinationCountry"
              label="Destination Country"
              placeholder="Select destination country"
              :items="destinationCountries"
              :rules="destinationCountryRules"
              @change="onDestinationCountryChange"
              required
              outlined
            ></v-select>

            <!-- Port -->
<!--            <v-select
              v-model="ddsForm.destinationPort"
              label="Destination Port"
              placeholder="Select destination port"
              :items="destinationPorts"
              :rules="destinationPortRules"
              :disabled="!ddsForm.destinationCountry"
              required
              outlined
            ></v-select>-->

            <v-text-field
              v-model="ddsForm.destinationPort"
              label="Destination Port"
              placeholder="Enter destination port"
              :rules="destinationPortRules"
              :disabled="!ddsForm.destinationCountry"
              required
              outlined
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="closeDdsDialog"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            :loading="ddsLoading"
            @click="submitDds"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'

  export default {
    name: 'buyerinvoices',
    data: function () {
      return {
        headers: [
          { text: 'Outturn Number', value: 'outturnNumber' },
          { text: 'Miller Code', value: 'millerCode' },
          { text: 'Broker Code', value: 'brokerCode' },
          { text: 'Pockets', value: 'pockets' },
          { text: 'Season', value: 'season' },
          { text: 'Marks', value: 'marks' },
          { text: 'Pockets', value: 'pockets' },
          { text: 'Net Weight', value: 'netWeight' }
        ],
        data: [],
        message: '',
        error: '',
        loading: false,
        loadingPage: false,
        // pagination: {
        //   sortBy: 'name'
        // },
         pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
        ddsDetailsDialog: false,
        ddsDetailsLoading: false,
        ddsAcceptLoading: false,
        ddsRejectLoading: false,
        ddsDetails: {
          id: null,
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        },
        ddsDialog: false,
        ddsFormValid: false,
        ddsLoading: false,

        selectedDdsFile: null,

        ddsForm: {
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        },

        destinationCountries: [],
        countriesLoading: false,

        destinationPorts: [],

        destinationPortMap: {
          Germany: ["Hamburg", "Bremen"],
          Italy: ["Trieste", "Genoa", "Napoli"],
          Belgium: ["Antwerp"],
          Spain: ["Barcelona"],
          France: ["Le Havre"],
          Netherlands: ["Rotterdam"],
          Estonia: ["Tallinn"],
        },
        buyerNameRules: [
          (v) =>
            !!v && v.trim().length > 0 ||
            "Buyer name is required",
        ],

        destinationCountryRules: [
          (v) =>
            !!v && v.trim().length > 0 ||
            "Destination country is required",
        ],

        destinationPortRules: [
          (v) =>
            !!v && v.trim().length > 0 ||
            "Destination port is required",
        ],
        totalData: 0,
        snackbar: false,
        snackbarColor: '',
        messsage: '',
        editedItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        defaultItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        selected: [],
        rejectInvoice: { marketer: {}, totalValue: '' },
        rejectDialog: false,
        processingRequest: false,
        showProgressBar: false
      }
    },
    mounted () {
      // this.getBuyerInvoices()
      this.fetchDestinationCountries();
    },
    watch: {

        pagination: {
    handler() {
      this.getToGenerateDDS();
    },
    deep: true
  }
    },

    computed: {
      canGenerateInvoice: function () {
        if (this.selected.length === 0 || this.processingRequest) {
          return true // Disable the button if nothing is selected or a request is being processed
        } else {
          return false // Enable the button if there are selected records and no request is being processed
        }
      }
    },
    methods: {
      fetchDestinationCountries() {
        this.countriesLoading = true;
        const url = config.serverURI + '/udr/destination-countries';

        axios.get(url)
          .then((response) => {
            this.destinationCountries = response.data;
          })
          .catch((error) => {
            console.error('Error fetching countries:', error);
            this.message = error.response?.data?.message || 'Unable to load countries';
            this.snackbarColor = 'error';
            this.snackbar = true;
          })
          .finally(() => {
            this.countriesLoading = false;
          });
      },
      onDestinationCountryChange(country) {
        this.destinationPorts =
          this.destinationPortMap[country] || [];

        // Clear the previously selected port
        this.ddsForm.destinationPort = "";
      },
      openDdsDialog(item) {
        this.selectedDdsFile = item;
        console.log('item - ', item)
        this.ddsForm = {
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        };

        this.destinationPorts = [];

        this.ddsFormValid = false;
        this.ddsDialog = true;

        this.$nextTick(() => {
          if (this.$refs.ddsForm) {
            this.$refs.ddsForm.resetValidation();
          }
        });
      },
      closeDdsDialog() {
        this.ddsDialog = false;

        this.selectedDdsFile = null;

        this.ddsForm = {
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        };

        this.destinationPorts = [];

        this.$nextTick(() => {
          if (this.$refs.ddsForm) {
            this.$refs.ddsForm.resetValidation();
          }
        });
      },
      submitDds() {
        const isValid = this.$refs.ddsForm.validate();

        if (!isValid) {
          return;
        }

        const payload = {
          buyerName: this.ddsForm.buyerName.trim(),
          destinationCountry: this.ddsForm.destinationCountry,
          destinationPort: this.ddsForm.destinationPort,
          grnIds: this.selected.map((item) => item.id),
        };

        console.log("Generate invoice + DDS payload:", payload);

        const url = config.serverURI + "/direct_grn/confirm";

        this.processingRequest = true;
        this.showProgressBar = true;
        this.ddsLoading = true;

        axios
          .post(url, payload)
          .then((response) => {
            this.snackbar = true;

            if (response.data.error !== false) {
              this.message = response.data.message;
              this.snackbarColor = "error";
              return;
            }

            this.message = response.data.message;
            this.snackbarColor = "primary";
            this.selected = [];
            this.closeDdsDialog();
            this.getToGenerateDDS();
          })
          .catch((error) => {
            const data = error.response?.data;
            this.message = data?.message || data?.status || "Request failed";
            this.snackbarColor = "error";
            this.snackbar = true;
          })
          .finally(() => {
            this.processingRequest = false;
            this.showProgressBar = false;
            this.ddsLoading = false;
          });
      },
      showDdsDetails(item) {
        this.ddsDetailsLoading = true;
        this.ddsDetailsDialog = true;

        const url =
          config.serverURI +
          "/direct_grn/dds-details?fileId=" +
          item.id;

        axios
          .get(url)
          .then((response) => {
            console.log("DDS Details:", response.data);

            this.ddsDetails = {
              id: response.data.id,
              buyerName: response.data.buyerName,
              destinationCountry: response.data.destinationCountry,
              destinationPort: response.data.destinationPort,
            };
          })
          .catch((error) => {
            console.error("Error fetching DDS details:", error);

            this.ddsDetailsDialog = false;

            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message:
                error.response?.data?.message ||
                "Unable to retrieve DDS details",
            });
          })
          .finally(() => {
            this.ddsDetailsLoading = false;
          });
      },
      closeDdsDetailsDialog() {
        this.ddsDetailsDialog = false;

        this.ddsDetails = {
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        };
      },
      acceptDds() {

        console.log('ddsDetails = ', this.ddsDetails)
        if (!this.ddsDetails.id) {
          return;
        }

        this.ddsAcceptLoading = true;

        const url =
          config.serverURI +
          "/direct_grn/dds-details/" +
          this.ddsDetails.id +
          "/accept";

        axios
          .put(url)
          .then((response) => {

            console.log("DDS accepted:", response.data);

            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "primary",
              message:
                response.data.message ||
                "DDS details accepted successfully",
            });

            this.ddsDetailsDialog = false;

            // Refresh dispatch files
            this.$store.dispatch(
              "grnfile/getDirectSaleFilesWithPagination",
              {
                size: this.numberOfItemsPerPage,
                page: this.currentPage,
              }
            );

          })
          .catch((error) => {

            console.error("Error accepting DDS:", error);

            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message:
                error.response?.data?.message ||
                "Failed to accept DDS details",
            });

          })
          .finally(() => {
            this.ddsAcceptLoading = false;
          });
      },
      rejectDds() {

        if (!this.ddsDetails.id) {
          return;
        }

        this.ddsRejectLoading = true;

        const url =
          config.serverURI +
          "/direct_grn/dds-details/" +
          this.ddsDetails.id +
          "/reject";

        axios
          .put(url)
          .then((response) => {

            console.log("DDS rejected:", response.data);

            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "primary",
              message:
                response.data.message ||
                "DDS details rejected successfully",
            });

            this.ddsDetailsDialog = false;

            this.$store.dispatch(
              "grnfile/getDirectSaleFilesWithPagination",
              {
                size: this.numberOfItemsPerPage,
                page: this.currentPage,
              }
            );

          })
          .catch((error) => {

            console.error("Error rejecting DDS:", error);

            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message:
                error.response?.data?.message ||
                "Failed to reject DDS details",
            });

          })
          .finally(() => {
            this.ddsRejectLoading = false;
          });
      },
      closeInvoiceDialog () {
        this.rejectInvoice = { marketer: {}, totalValue: '' }
        this.rejectDialog = false
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        this.sendRequest()
        this.close()
      },
      sendRequest () {
        const url = config.serverURI + '/invoice/requesteslip'
        axios.post(url, this.editedItem)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.data = this.getToGenerateDDS()
            this.message = response.data.message
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
      },
   getToGenerateDDS() {
  console.log('Fetching invoices with pagination:', this.pagination);
  this.loadingPage = true;

  const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;

  let size = itemsPerPage;
  if (size === -1) {
    size = this.totalData || 1000; // fallback if totalInvoices unknown
  }

  // Convert Vuetify options to backend params
  const params = {
    page: page - 1, // Backend usually starts from 0
    size: size,
    sort: sortBy.length ? `${sortBy[0]},${sortDesc[0] ? 'desc' : 'asc'}` : null
  };

  // Remove null params
  Object.keys(params).forEach(key => params[key] === null && delete params[key]);

  const url = config.serverURI + '/udr/generate';

  axios.get(url, { params })
    .then(response => {
      console.log('Response data:', response.data);
      this.data = response.data.content || response.data.items || [];
      console.log('this data:', this.data);
      this.totalData = response.data.totalElements || response.data.total || 0;
      console.log('this totalData:', this.totalData);
    })
    .catch(error => {
      console.error('error', error);
      this.message = error.response?.status || 'Request failed';
      this.snackbar = true;
      this.snackbarColor = 'error';
    })
    .finally(() => {
      this.loadingPage = false;
    });
},
      generateInvoice () {
        // this.processingRequest = true
        // this.showProgressBar = true
        // console.log(this.selected)
        // this.sendGenerateInvoiceRequest()
        if (this.selected.length === 0) {
          return;
        }
        this.ddsForm = {
          buyerName: "",
          destinationCountry: "",
          destinationPort: "",
        };
        this.destinationPorts = [];
        this.ddsFormValid = false;
        this.ddsDialog = true;

        this.$nextTick(() => {
          if (this.$refs.ddsForm) {
            this.$refs.ddsForm.resetValidation();
          }
        });
      },
      sendGenerateInvoiceRequest () {
        const url = config.serverURI + '/invoice/confirm'
        axios.post(url, this.selected)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.message = response.data.message
            this.snackbarColor = 'primary'
            this.selected = []
            this.getToGenerateDDS()
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
          .finally(() => {
            this.processingRequest = false
            this.showProgressBar = false
            // this.loadingPage = false
          })
      },
      triggerDownload (item) {
        var url = config.serverURI + '/invoice/download/' + item.id
        axios.get(url)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const itemFileName = item.marketer.organisationName + '_' + item.created
            link.setAttribute('download', itemFileName)
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.message = error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
          })
        return this.data
      }
    }
  }

  </script>
  <style>
  .text {
    font-style: 'Open Sans';
    font-size: 16px;
    color: #000;
  }
  </style>
